import type { MenuProps } from 'antd';

import { MenuCategory, MenuItem } from './types';
import { AppDropdown, AppFlex, AppSpace } from '../../Atoms';
import { DropdownRotatingArrow } from '@/react_app/common';
import { AppIcon } from '@/react_app/common/AppIcon';
import { ExtendedReactElement } from '@/utils/types';

function MenuItem({ item }: { item: MenuItem }) {
	return (
		<AppFlex align="center" justify="space-between" className="h-[34px]">
			<AppSpace>
				{item.icon && <AppIcon name={item.icon} height={24} width={24} />}
				{item.label}
			</AppSpace>
			<div>{item.expandable && <DropdownRotatingArrow />}</div>
		</AppFlex>
	);
}

type Items = MenuProps['items'];

export const Menu = ({ categories, children }: ExtendedReactElement<{ categories: MenuCategory[] }>) => {
	const items: Items = categories
		.map((category, i) => {
			const curItems: Items = category.items.map((item, j) => ({
				key: `${i}-${j}`,
				item,
				label: <MenuItem item={item} />,
			}));
			if (i + 1 !== categories.length) {
				curItems.push({ type: 'divider' });
			}
			return curItems;
		})
		.flat(1);
	const onClick: MenuProps['onClick'] = (payload) => {
		const item = items.find((i) => i && i.key === payload.key);
		item?.item.onClick?.();
	};
	return (
		<AppDropdown menu={{ items, onClick }} trigger={['click']} overlayClassName="w-[300px]" placement="top">
			{children}
		</AppDropdown>
	);
};
